<template lang="pug">
  div.map-container.geo.map-objects
    div.toolbar
      div.line
        h1.title Карта

    div.new-map
      div(ref="map" v-once).bigmap#map

      transition(name="fade")
        div.legend.legend--objects.cuscroll(:class="showMapLegend ? 'open' : 'close'")
          e-perfect-scrollbar
            div.head(@click="showMapLegend = !showMapLegend")
              h2.title Слои
              //span.toolbar-filter__close
              span.legend__close(v-if="showMapLegend")
              span.legend__open(v-else)
            div(v-for="item, name in layersConf" :class="'type-group ' + item.menuClass")
              div.type
                label.checked
                  input.checkbox(type="checkbox" @change="onLayersChange(item, name)" v-model="layers" :value="name")
                  span
                  span.marker {{item.label}}
                label.new-check
                  input.new-checkbox(type="checkbox")
                  span
              template(v-if="item.groups" v-for="groupItem, groupItemName in item.groups")
                div(v-if="groupItem && !groupItem.hideFromMenu").group
                  div(:class="'type ' + groupItem.menuClass")
                    label.checked
                      input.checkbox(type="checkbox" @change="onLayersChange(groupItem, groupItemName, name)" v-model="layers" :value="groupItemName")
                      span
                      span.marker {{groupItem.label}}

            div.type-group.map-mapping-selector
              div.type
                label.checked
                  span
                  span.marker % Заполненности
                label.new-check
                  input.new-checkbox(type="checkbox")
                  span(style="visibility: hidden;")

              div(
                v-for="option in fullnessOptions"
              ).group
                div.type
                  label.checked
                    input(
                      type="checkbox"
                      v-model="fullness"
                      @change="onChangeFullness"
                      :value="option.id"
                    ).checkbox
                    span.marker-field
                    span.marker {{option.name}}

            div.type-group.is-map-legend
              div.type-group
                div.type
                  label.checked
                    input.checkbox(type="checkbox")
                    span
                    span.marker Статус
                  label.new-check
                    input.new-checkbox(type="checkbox")
                    span
              div.group
                div.type.sensor-status-active
                  label.checked
                    input.checkbox(type="checkbox")
                    span
                    span.marker Действующий
                div.type.sensor-status-alarmed
                  label.checked
                    input.checkbox(type="checkbox")
                    span
                    span.marker Аварийный
                div.type.sensor-status-broken
                  label.checked
                    input.checkbox(type="checkbox")
                    span
                    span.marker Неисправный

    router-view

</template>
<style>
  .geo .map-mapping-selector .group .marker {
    padding-left: 25px !important;
  }
</style>
<script>
    import 'leaflet';

    import url from '../../../utils/url.js'
    import {MAP, TILE_LAYER} from '../../../config/map.js'
    import {POLYGON} from "../../../config/polygon";
    import layersMixin from '../../../mixins/layers-mixin.js'
    import {map as mapEndpoints} from '../../../api/api-endpoints.js'
    import ObjectsLayerDrawer from '../utils/ObjectsLayerDrawer.js'

    export default {
        name: 'objects',
        data() {

            this.mapLayers = null
            this.map = null

            return {
                fullness: [],
                layers: []
            }
        },
        mixins: [layersMixin],
        computed: {
            mapBorders() {
                return this.$store.getters.readUrlEndpoint(mapEndpoints.mo())
            },
            module() {
                return 'geo'
            },
            fullnessOptions() {
                return [
                    {id: 1, name: 'Пустые (0-50%)'},
                    {id: 2, name: 'Скоро заполнятся (50%-90%)'},
                    {id: 3, name: 'Полные (100%)'}
                ]
            }
        },
        methods: {
            onChangeFullness() {
                this.$bar.start().set(12)
                setTimeout(() => {
                    this.replaceRoute({fullness: this.fullness}, false)
                }, 50)
            },
            routeHandler(newVal, oldVal) {
                this.setFiltersFromUrl()
                this.setDataToLayersFromStore()
            },
            setFiltersFromUrl() {
                if (this.$route.query.layers) {
                    let route = url.getRoute(this.$route)
                    if (typeof route.query['layers'] === 'string') {
                        this.layers = route.query['layers'].split(',')
                    }
                }
                if (this.$route.query.fullness) {
                    let route = url.getRoute(this.$route)
                    if (typeof route.query.fullness === 'string') {
                        this.fullness = route.query.fullness.split(',')
                    }
                }
            },
            getMapConfigData() {
                return MAP
            },
            getMapPolygon() {
                return POLYGON
            },
            drawTiles() {
                L.tileLayer(TILE_LAYER, {}).addTo(this.map)
            },
            getLayersConf() {
                return {
                    msn: {
                        iconType: 'places',
                        menuClass: 'places',
                        label: 'Места сбора и накопления',
                        endpoint: mapEndpoints.msn,
                        className: 'cluster-marker msn',
                        groups: {
                            container: {
                                menuClass: 'places-cont',
                                iconType: 'container',
                                label: 'Контейнерные площадки',
                                restApiOrder: 1
                            },
                            noContainer: {
                                menuClass: 'places-noCont',
                                iconType: 'noContainer',
                                label: 'Бесконтейнерный сбор',
                                restApiOrder: 2
                            },
                            separate: {
                                menuClass: 'places-points',
                                iconType: 'separate',
                                label: 'Пункты сбора вторсырья',
                                restApiOrder: 3
                            }
                        }
                    }
                }
            },
            afterMapInit() {
                this.objectsLayerDrawer = new ObjectsLayerDrawer(this.map, {vm: this})
                this.mapLayers = this.objectsLayerDrawer.setLayersConfigAndDraw(this.layersConf)
            },
            destroyMap() {
                console.log('destroyed')
                this.$emitter.emit('geo.destroyMap', {})
                // this.map.remove()
                this.map = null
            },
            getParentsConf(layersArr, conf) {
                let parents = {}
                for (let key in conf) {
                    if (layersArr.indexOf(key) > -1) {
                        parents[key] = conf[key]
                    }

                    if (conf[key].hasOwnProperty('groups')) {
                        for (let childKey in conf[key].groups) {
                            if (layersArr.indexOf(childKey) > -1) {
                                parents[key] = conf[key]
                            }
                        }
                    }
                }

                return parents
            },
            getLayerEndpoint(conf, type, route) {
                if (conf[type] && conf[type].endpoint) {
                    const q = {query: {}}
                    if (route.query.fullness) {
                        q.query.fullness = route.query.fullness.split(',')
                    }
                    return conf[type].endpoint('', q)
                }
                return null
            },
            afterReCreateMap() {
                this.objectsLayerDrawer.removeLayers()
                this.mapLayers = null
                this.afterMapInit()
            }
        },
        asyncData({store, route, fromRoute, methods}) {
            let promises = []
            let usedRoute = url.getPrevOrCurrentRoute(route)

            if (usedRoute.query && usedRoute.query.layers && typeof usedRoute.query.layers === 'string') {
                let conf = methods.getParentsConf(usedRoute.query.layers.split(','), methods.getLayersConf())
                for (let key in conf) {
                    if (methods.getLayerEndpoint(conf, key, usedRoute)) {
                        // console.log('asyncData ' + methods.getLayerEndpoint(conf, key, route))

                        promises.push(store.dispatch('updateUrlEndpoint', {
                            endpoint: methods.getLayerEndpoint(conf, key, usedRoute),
                            // cache: (60 * 60 * 24 * 1000)
                        }))
                    }
                }
            }

            promises.push(store.dispatch('updateUrlEndpoint', {
                endpoint: mapEndpoints.mo(),
                fromCache: true
            }))

            if (promises.length === 0) {
                return Promise.resolve(1)
            }

            return Promise.all(promises)
        }
    };
</script>
